import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-device-service-schema'
import config from './req.config'
export type { paths as DevicePaths }

export const deviceServiceReq = createFetchClient<paths>({
  ...config,
})

export const deviceServiceQuery = createClient<paths>(deviceServiceReq)
